import { AuxCheckbox } from "@blk/aladdin-react-components-es";
import React from "react";
import { useDispatch } from "react-redux";
import { useWidgetCurrentExcludeSoldAssets } from "components/widgets/hooks/use-current-widget";
import { language } from "language/default";
import { setCurrentStatusExcludeSoldAssets } from "store/current-dashboard";
export const InsSettingsExcludeSoldAssets = (props) => {
    const dispatch = useDispatch();
    const { sectionId, widgetId } = props, excludeSoldAssets = useWidgetCurrentExcludeSoldAssets(sectionId, widgetId);
    const onCheckboxChanged = (data) => {
        dispatch(setCurrentStatusExcludeSoldAssets({ excludeSoldAssets: data.detail.value.checked,
            sectionId,
            widgetId }));
    };
    return React.createElement(AuxCheckbox, { label: language.en.skeleton.settingsMenu.excludeSoldAssets, isChecked: excludeSoldAssets, onCheckboxChanged: onCheckboxChanged });
};
